export const NAMES = {
    GREATER_OR_EQUAL: 'Maior ou igual a',
    LESSER_OR_EQUAL: 'Menor ou igual a',
    BETWEEN: 'Entre',
    NONE: 'Não importa',

    KEEP_LIMIT: 'Manter Limite',
    RAISE_LIMIT: 'Aumentar Limite',
    REDUCE_LIMIT: 'Diminuir Limite',
    ZERO_LIMIT: 'Zerar Limite'
}

export const FORM_LABELS = {
    GREATER_OR_EQUAL: 'greaterOrEqual',
    LESSER_OR_EQUAL: 'lesserOrEqual',
    BETWEEN: 'between',
    NONE: 'none',

    KEEP_LIMIT: 'keepLimit',
    RAISE_LIMIT: 'raiseLimit',
    REDUCE_LIMIT: 'reduceLimit',
    ZERO_LIMIT: 'zeroLimit'
}